import { SET_HAS_GROUPS_CONFIG_ERRORS } from '../actionTypes';
import { actions } from '../reducer';

export default (values) => actions[SET_HAS_GROUPS_CONFIG_ERRORS](values);
